import { Injectable, inject } from '@angular/core';
import { RootServicesModule } from './root-services.module';
import { Observable } from 'rxjs';
import { IUser, ISCDUser, IUserSettings } from '@app-root-interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app-environment';
import { EUserRole } from '@app-root-enums';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: RootServicesModule
})
export class UserService {
    private http = inject(HttpClient);

    public getUser(gid: string): Observable<{ user: IUser; isAdmin: boolean }> {
        return this.http.get<IUser>(`${environment.gatewayAPI}/user/${gid}`).pipe(
            map((user) => ({
                user,
                isAdmin: sessionStorage.getItem('isAdmin') === 'true'
            }))
        );
    }

    public createInitialUser(scdUser: ISCDUser): Observable<IUser> {
        const user: IUser = {
            gid: scdUser.gid,
            role: EUserRole.USER
        };
        return this.http.post<IUser>(`${environment.gatewayAPI}/user`, user);
    }

    public toogleFavourites(user: IUser, documentKey: string): Observable<IUser> {
        let favoritDocuments = [...user.favoritDocuments];
        if (favoritDocuments.includes(documentKey)) {
            favoritDocuments = favoritDocuments.filter((doc) => doc !== documentKey);
        } else {
            favoritDocuments.push(documentKey);
        }
        return this.http.patch<IUser>(`${environment.gatewayAPI}/user/${user.gid}`, { favoritDocuments });
    }

    public addToRecentlySeen(user: IUser, documentKey: string): Observable<IUser> {
        const MAX_N_RECENT_DOCUMENTS = 5;
        let recentDocuments = [...user.recentDocuments];
        if (recentDocuments.includes(documentKey)) {
            recentDocuments = recentDocuments.filter((doc) => doc !== documentKey);
        }
        recentDocuments.push(documentKey);
        if (recentDocuments.length > MAX_N_RECENT_DOCUMENTS) {
            const diff = recentDocuments.length - MAX_N_RECENT_DOCUMENTS;
            recentDocuments.splice(0, diff);
        }
        return this.http.patch<IUser>(`${environment.gatewayAPI}/user/${user.gid}`, { recentDocuments });
    }

    public updateUserSettings(user: IUser, settings: IUserSettings) {
        return this.http.patch<IUser>(`${environment.gatewayAPI}/user/${user.gid}`, { settings });
    }
}
